import React from 'react'
import {
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SidebarMenu,
    SidebarLink,
    SidebarBtn,
    SidebarBtnLink
} from './SidebarElements';

const Sidebar = ({isOpen, toggle}) => {
    return (
        <>
            <SidebarContainer isOpen={isOpen} onClick={toggle}>
                <Icon onClick={toggle}>
                    <CloseIcon></CloseIcon>
                </Icon>
                <SidebarWrapper>
                    <SidebarMenu>
                        <SidebarLink to="pocetna" onClick={toggle}
                        smooth={true} duration={500} spy={true} exact='true' offset={-80}
                        >Početna</SidebarLink>

                        <SidebarLink to="about" onClick={toggle}
                        smooth={true} duration={500} spy={true} exact='true' offset={-80}
                        >O konferenciji</SidebarLink>

                        <SidebarLink to="presenters" onClick={toggle}
                        smooth={true} duration={500} spy={true} exact='true' offset={-80}
                        >Izlagači</SidebarLink>

                        <SidebarLink to="raspored" onClick={toggle}
                        smooth={true} duration={500} spy={true} exact='true' offset={-80}
                        >Raspored</SidebarLink>

                        <SidebarLink to="slike" onClick={toggle}
                        smooth={true} duration={500} spy={true} exact='true' offset={-80}
                        >Slike</SidebarLink>

                        <SidebarLink to="kontakt" onClick={toggle}
                        smooth={true} duration={500} spy={true} exact='true' offset={-80}
                        >Kontakt</SidebarLink>
                    </SidebarMenu>
                    <SidebarBtn>
                        <SidebarBtnLink to="kontakt"
                        smooth={true} duration={500} spy={true} exact='true' offset={-80}
                        >Prijavi se</SidebarBtnLink>
                    </SidebarBtn>
                </SidebarWrapper>
            </SidebarContainer>
        </>
    )
}

export default Sidebar